import script from "./SessionHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./SessionHistoryView.vue?vue&type=style&index=0&id=560f8e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560f8e4e"]])

export default __exports__